<template>
  <div class="ui-report-work" :class="isTop ? 'top' : ''" ref="reportWork">
    <WorkList :worksList="worksList" @resfresPraise="handleRefreshPrasie" />
  </div>
</template>

<script>
import WorkList from "@/components/WorkList"
import { mapGetters, mapMutations } from "vuex"

export default {
  name: "uiReportWork",
  data() {
    return {
      isTop: false
    }
  },
  methods: {
    ...mapMutations({
      reviseWorkItem: "home/reviseWorkItem"
    }),
    toggleBorderRadius(scrollEvent) {
      const target = scrollEvent.target.scrollingElement
      const scrollTop = target.scrollTop
      const offsetTop = this.$refs.reportWork.offsetTop
      const isToTop = scrollTop === offsetTop
      this.isTop = isToTop
    },
    initScrollEvent() {
      document.onscroll = e => {
        if (this.scrollTimer) {
          window.clearTimeout(this.scrollTimer)
          this.scrollTimer = null
        }
        this.scrollTimer = window.setTimeout(() => {
          this.toggleBorderRadius(e)
        }, 17)
      }
    },
    handleRefreshPrasie(praiseOptions) {
      this.reviseWorkItem(praiseOptions)
    },
    init() {
      this.initScrollEvent()
    }
  },
  components: {
    WorkList
  },
  computed: {
    ...mapGetters({
      worksList: "home/worksList"
    })
  },
  created() {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.ui-report-work {
  height: auto;
  width: 100%;
  background: #ffffff;
  position: relative;
  z-index: 10;
  border-radius: 0.3rem 0.3rem 0 0;
  transition: all 100ms ease-in-out;
  &.top {
    border-radius: 0;
  }
}
</style>
